module.exports = __webpack_public_path__ + "static/media/right-white.2a118d54.svg";